export const getDate = (dateStr: string) => new Date(dateStr.replace(/-/g, "/"))

export const formatTime = (date: Date) => {
  const hours = String(date.getHours()).padStart(2, "0")
  const minutes = String(date.getMinutes()).padStart(2, "0")
  return `${hours}:${minutes}`
}
